import { useEffect } from "react";
import { useAppSelector } from "../app/hooks";
import { themeVariables } from "../utils/themes";

const useTheme = () => {
  const theme = useAppSelector((state) => state.activeTemplate.theme);

  useEffect(() => {
    if (!theme) return;
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  return theme ? themeVariables[theme] : undefined;
};

export default useTheme;
